import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

const BG = "https://images.unsplash.com/photo-1595936398510-7057e9288156?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function CTABanner() {
    return (
        <section data-testid="cta-banner" className="relative overflow-hidden">
            <img src={BG} alt="Open ocean" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#040914] via-[#040914]/85 to-[#040914]/40" />
            <div className="absolute inset-0 wms-grid-bg opacity-30" />

            <div className="relative wms-container py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-7">
                    <span className="wms-overline">Charter Desk · Open</span>
                    <h2 className="mt-5 font-display font-light text-4xl md:text-6xl leading-[1.05] tracking-tight">
                        Tell us your laycan.
                        <br />
                        <span className="text-[#48CAE4] italic">We'll build the voyage.</span>
                    </h2>
                    <p className="mt-6 max-w-xl text-white/65 text-base md:text-lg">
                        Share your cargo, route and timing — our chartering desk will return with vetted tonnage, voyage estimate and a fixture proposal within 24 hours.
                    </p>
                </div>
                <div className="lg:col-span-5 flex flex-col gap-4">
                    <Link
                        to="/contact?intent=charter"
                        data-testid="cta-banner-charter"
                        className="group inline-flex items-center justify-between gap-3 px-7 py-5 bg-white text-[#040914] text-xs uppercase tracking-[0.24em] font-medium hover:bg-[#48CAE4] transition-colors"
                    >
                        <span>Request a Charter</span>
                        <ArrowUpRight size={18} weight="bold" />
                    </Link>
                    <Link
                        to="/contact"
                        data-testid="cta-banner-contact"
                        className="group inline-flex items-center justify-between gap-3 px-7 py-5 border border-white/20 text-white text-xs uppercase tracking-[0.24em] font-medium hover:border-[#48CAE4] hover:text-[#48CAE4] transition-colors"
                    >
                        <span>Reach Operations</span>
                        <ArrowUpRight size={18} weight="bold" />
                    </Link>
                    <a
                        href="mailto:chartering@windermereinland.com"
                        data-testid="cta-banner-email"
                        className="text-xs uppercase tracking-[0.28em] text-white/50 hover:text-white mt-2"
                    >
                        chartering@windermereinland.com
                    </a>
                </div>
            </div>
        </section>
    );
}
